import React, { Component } from 'react';
import { Tabs, Tab, Button, ButtonToolbar, Col } from 'react-bootstrap';
import Toggle from 'react-toggle'

import { PropTypes } from 'prop-types';
import { LinesCommand } from '../commands/LinesCommand';
import { LinesDraftCommand } from '../commands/LinesDraftCommand';
import { LineColorsCommand } from '../commands/LineColorsCommand';
import { RegionsCommand } from '../commands/RegionsCommand';
import { HandleMessage } from '../../HandleMessage';
import { HandleDialog } from '../../HandleDialog';
import { LineActiveForm } from './LineActiveForm';
import { LineDraftForm } from './LineDraftForm';
import { LinesActive } from './LinesActive';
import { LinesDraft } from './LinesDraft';
import { LoadingSpinner } from '../../LoadingSpinner';
import { PaginationHelper } from '../../helpers/PaginationHelper';
import { SearchBar } from '../../SearchBar';
import { TitleRow } from '../../TitleRow';
import { EditionSelector } from '../../EditionSelector';

export class Lines extends Component {
    static contextTypes = {
        selectApp: PropTypes.func,
        selectedProvider: PropTypes.string,
        edition: PropTypes.object,
        addEditionObserver: PropTypes.func,
        removeEditionObserver: PropTypes.func
    }

    constructor(props) {
        super(props);

        this.state = {
            data: {
                active: {
                    lines: [],
                },
                draft: {
                    lines: [],
                }
            },
            dependencies: {
                regions: [],
                lineColors: []
            },
            form: {
                active: {
                    line: undefined
                },
                draft: {
                    line: undefined
                }
            },
            render: {
                tab: "active",
                compare: false,
                filter: ""
            },
            pagination: {
                active: {
                    page: 1,
                    elementsPerPage: 10
                },
                draft: {
                    page: 1,
                    elementsPerPage: 10
                }
            },
            actions: {
                active: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                draft: {
                    isLoading: true,
                    isUpdating: false,
                    isDeleting: false,
                },
                isLoadingLineColors: true,
                isLoadingRegions: true,
                isLoadingEditions: false,
            },
            commands: {
                active: {
                    lines: new LinesCommand(),
                },
                draft: {
                    lines: new LinesDraftCommand(),
                },
                lineColors: new LineColorsCommand(),
                regions: new RegionsCommand(),
            },
            message: {
                show: false,
                message: undefined,
                style: undefined,
                icon: undefined,
                title: ""
            },
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        }
    }

    componentDidMount() {
        this.context.selectApp('datamanager', false);
        this.context.addEditionObserver(this);

        // Not associated with any type of Edition
        this.getLineColors();
        this.getRegions();
    }

    componentWillUnmount() {
        this.context.removeEditionObserver(this);
    }

    // ----------------------

    startUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = true;

        this.setState({
            actions: actions
        });
    }

    endUpdate() {
        const { actions } = this.state;

        actions.isLoadingEditions = false;

        this.setState({
            actions: actions
        });
    }

    updateNetwork() {
        const { actions } = this.state;

        actions.active.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "active");
        });
    }

    updateDraftNetwork() {
        const { actions } = this.state;

        actions.draft.isLoading = true;

        this.setState({
            actions: actions
        }, () => {
            const { edition } = this.context;

            this.getLines(edition, "draft");
        });
    }

    // ----------------------

    listSuccessCallback(result, dataType, updateData, updateAction, callback) {
        const { data, pagination, actions } = this.state;
        const totalPages = PaginationHelper.getTotalPages(result.length, pagination[dataType].elementsPerPage);

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = result;
        if (0 !== totalPages) {
            pagination.page = pagination.page > totalPages ? totalPages : pagination.page;
        }
        else {
            pagination.page = 1;
        }

        // Update data
        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listErrorCallback(messageReceived, dataType, updateData, updateAction) {
        const { data, pagination, actions, message } = this.state;

        actions[dataType][updateAction] = false;
        data[dataType][updateData] = [];
        pagination[dataType].page = 1;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            data: data,
            actions: actions,
            pagination: pagination,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    listDependenciesSuccessCallback(result, updateData, updateAction, callback) {
        const { dependencies, actions } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = result;

        // Update data
        this.setState({
            dependencies: dependencies,
            actions: actions
        }, () => {
            if ("function" === typeof (callback)) {
                callback();
            }
        });
    }

    listDependenciesErrorCallback(messageReceived, updateData, updateAction) {
        const { dependencies, actions, message } = this.state;

        actions[updateAction] = false;
        dependencies[updateData] = [];

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            dependencies: dependencies,
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    operationSuccessCallback(result, updateAction, dataType, callback) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            result.message = `${message.message}\n${result.message}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: result.message,
                style: "success",
                title: "Sucesso",
                icon: "ok"
            }
        });

        if ("function" === typeof (callback)) {
            callback(result.data);
        }
    }

    operationErrorCallback(messageReceived, updateAction, dataType) {
        const { actions, message } = this.state;

        actions[dataType][updateAction] = false;

        if (message.show) {
            messageReceived = `${message.message}\n${messageReceived}`;
        }

        this.setState({
            actions: actions,
            message: {
                show: true,
                message: messageReceived,
                style: "danger",
                title: "Erro",
                icon: "remove"
            }
        });
    }

    // ----------------------

    getLines(edition, dataType) {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions[dataType].isLoading = true;
        commands[dataType].lines.get(
            edition,
            selectedProviderId,
            (a) => this.listSuccessCallback(a, dataType, "lines", "isLoading"),
            (a) => this.listErrorCallback(a, dataType, "lines", "isLoading")
        );

        this.setState({
            actions: actions
        });
    }

    getRegions() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoadingRegions = true;
        commands.regions.getAll(
            selectedProviderId,
            (a) => this.listDependenciesSuccessCallback(a, "regions", "isLoadingRegions"),
            (a) => this.listDependenciesErrorCallback(a, "regions", "isLoadingRegions")
        );

        this.setState({
            actions: actions
        });
    }

    getLineColors() {
        let selectedProviderId = '';
        if (this.context.selectedProvider !== undefined) {
            selectedProviderId = this.context.selectedProvider.split(':')[0];
        }

        const { commands, actions } = this.state;

        actions.isLoadingLineColors = true;
        commands.lineColors.getAll(
            selectedProviderId,
            (a) => this.listDependenciesSuccessCallback(a, "lineColors", "isLoadingLineColors"),
            (a) => this.listDependenciesErrorCallback(a, "lineColors", "isLoadingLineColors")
        );

        this.setState({
            actions: actions
        });
    }

    // ----------------------

    onSearch(filter) {
        const { render } = this.state;

        render.filter = filter;

        this.setState({
            render: render
        });
    }

    onSelectTab(key) {
        const { render } = this.state;

        render.tab = key;

        this.setState({
            render: render
        });
    }

    onToggleIsComparing() {
        const { render } = this.state;

        render.compare = !render.compare;

        this.setState({
            render: render
        });
    }

    onChangePage(page, dataType) {
        const { pagination } = this.state;

        pagination[dataType].page = page;

        this.setState({
            pagination: pagination
        });
    }

    onChangeElementsPerPage(elementsPerPage, dataType) {
        const { pagination } = this.state;

        pagination[dataType].elementsPerPage = elementsPerPage;

        this.setState({
            pagination: pagination
        });
    }

    onChangeValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].line.obj[value] = e.target.value;

        this.setState({
            form: form,
        });
    }

    onSelectValue(e, value, dataType) {
        const { form } = this.state;

        form[dataType].line.obj[value] = e;

        this.setState({
            form: form,
        });
    }

    onCreateClick(dataType) {
        const { form } = this.state;

        form[dataType].line = {
            title: "Criar",
            type: "create",
            original: undefined,
            obj: {
                id: 0,
                code: "",
                extCode: "",
                externalCode: "",
                goName: "",
                returnName: "",
                lineColor: undefined
            },
            codeInputError: null,
            goNameInputError: null
        };

        this.setState({
            form: form
        });
    }

    onEditLineClick(line, dataType) {
        const { form, render } = this.state;

        if (render.compare) {
            const { data } = this.state;

            line = data[dataType].lines.find(unmutedLine => unmutedLine.id === line.id);
        }

        form[dataType].line = {
            title: "Editar",
            type: "edit",
            original: line,
            obj: Object.assign({
                id: 0,
                code: "",
                extCode: "",
                externalCode: "",
                goName: "",
                returnName: "",
                lineColor: undefined
            }, line),
            codeInputError: null,
            goNameInputError: null
        };

        this.setState({
            form: form
        });
    }

    onLineFormExit(dataType) {
        const { form } = this.state;

        form[dataType].line = undefined;

        this.setState({
            form: form
        });
    }

    onDeleteClick(line, dataType) {
        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende eliminar a linha "${line.code}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "delete",
                    id: line.id,
                    dataType: dataType
                }
            }
        });
    }

    onTakeoverClick(line, dataType) {
        const obj = Object.assign({}, line);
        obj.controlledByTA = !obj.controlledByTA;

        this.setState({
            dialog: {
                show: true,
                title: "Aviso",
                message: `Tem a certeza que pretende alterar o controlo da linha "${line.code}"`,
                style: "warning",
                icon: "alert",
                argument: {
                    operation: "takeover",
                    id: line.id,
                    obj: obj,
                    dataType: dataType
                }
            }
        });
    }

    onSaveLine(dataType) {
        if (this.isValidInput(dataType)) {
            const { edition } = this.context;
            const { form, commands, actions } = this.state;

            actions[dataType].isUpdating = true;

            const callback = () => this.getLines(edition, dataType);
            commands[dataType].lines.save(
                edition,
                form[dataType].line.obj,
                (a) => this.operationSuccessCallback(a, "isUpdating", dataType, callback),
                (a) => this.operationErrorCallback(a, "isUpdating", dataType)
            );

            this.setState({
                actions: actions
            });

            this.onLineFormExit(dataType);
        }
    }

    onExitMessage() {
        this.setState({
            message: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined
            }
        });
    }

    onExitDialog(isToExecute, argument) {
        const { actions } = this.state;
        
        if (isToExecute) {
            const { edition } = this.context;
            const { commands } = this.state;

            switch (argument.operation) {
                case "delete":
                    actions[argument.dataType].isDeleting = true;
                    commands[argument.dataType].lines.delete(
                        edition,
                        argument.id,
                        (a) => this.operationSuccessCallback(a, "isDeleting", argument.dataType, () => this.getLines(edition, argument.dataType)),
                        (a) => this.operationErrorCallback(a, "isDeleting", argument.dataType)
                    );
                    break;

                case "takeover":
                    var providerId = this.context.selectedProvider.split(":")[0]
                    actions[argument.dataType].isUpdating = true;
                    commands[argument.dataType].lines.takeover(
                        edition,
                        argument.id,
                        argument.obj,
                        providerId,
                        (a) => this.operationSuccessCallback(a, "isUpdating", argument.dataType, () => this.getLines(edition, argument.dataType)),
                        (a) => this.operationErrorCallback(a, "isUpdating", argument.dataType)
                    );
                    break;

                default: // DO NOTHING
                    break;
            }
        }

        this.setState({
            actions: actions,
            dialog: {
                show: false,
                title: undefined,
                message: undefined,
                style: undefined,
                icon: undefined,
                argument: undefined
            }
        });
    }

    // ----------------------

    isValidInput(dataType) {
        const { form } = this.state;
        let errors = 0;

        form[dataType].line.codeInputError = null;
        form[dataType].line.goNameInputError = null;

        if (undefined === form[dataType].line.obj.code || null === form[dataType].line.obj.code || "" === form[dataType].line.obj.code) {
            form[dataType].line.codeInputError = 'error';
            errors++;
        }

        if (undefined === form[dataType].line.obj.goName || null === form[dataType].line.obj.goName || "" === form[dataType].line.obj.goName) {
            form[dataType].line.goNameInputError = 'error';
            errors++;
        }

        this.setState({
            form: form
        });

        return 0 === errors;
    }

    // ----------------------

    renderActiveForm() {
        const { form } = this.state;

        if (undefined === form.active.line) {
            return null;
        }

        const { dependencies } = this.state;

        return (
            <LineActiveForm show={true}
                form={form.active.line}
                lineColors={dependencies.lineColors}
                regions={dependencies.regions}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "active")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "active")}
                onSave={() => this.onSaveLine("active")}
                onHide={() => this.onLineFormExit("active")} />
        );
    }

    renderDraftForm() {
        const { form } = this.state;

        if (undefined === form.draft.line) {
            return null;
        }

        const { dependencies } = this.state;

        return (
            <LineDraftForm show={true}
                form={form.draft.line}
                lineColors={dependencies.lineColors}
                regions={dependencies.regions}
                onChangeValue={(a, b) => this.onChangeValue(a, b, "draft")}
                onSelectValue={(a, b) => this.onSelectValue(a, b, "draft")}
                onSave={() => this.onSaveLine("draft")}
                onHide={() => this.onLineFormExit("draft")} />
        );
    }

    renderLinesActive() {
        const { data, actions, render, pagination } = this.state;

        return (
            <LinesActive selectedProvider={this.context.selectedProvider} 
                lines={data.active.lines}
                draftLines={data.draft.lines}
                currentPage={pagination.active.page}
                elementsPerPage={pagination.active.elementsPerPage}
                isLoading={actions.active.isLoading || (render.compare && actions.draft.isLoading)}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "active")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "active")}
                onEditClick={(a) => this.onEditLineClick(a, "active")}
                onTakeoverClick={(a) => this.onTakeoverClick(a, "active")}
                onDeleteClick={(a) => this.onDeleteClick(a, "active")} />
        );
    }

    renderLinesDraft() {
        const { data, actions, pagination, render } = this.state;

        if (actions.draft.isLoading) {
            return (<LoadingSpinner />)
        }

        return (
            <LinesDraft selectedProvider={this.context.selectedProvider}
                lines={data.draft.lines}
                currentPage={pagination.draft.page}
                elementsPerPage={pagination.draft.elementsPerPage}
                isLoading={actions.draft.isLoading}
                filter={render.filter}
                isComparing={render.compare}
                onChangePage={(a) => this.onChangePage(a, "draft")}
                onChangeElementsPerPage={(a) => this.onChangeElementsPerPage(a, "draft")}
                onEditClick={(a) => this.onEditLineClick(a, "draft")}
                onDeleteClick={(a) => this.onDeleteClick(a, "draft")} />
        );
    }

    renderTabOptions(selectedTab) {
        if ("active" === selectedTab) {
            const { render } = this.state;

            return (
                <div className="tab-options">
                    <label>
                        <Toggle className="comparison-toggle"
                            checked={render.compare}
                            icons={false}
                            onChange={() => this.onToggleIsComparing()} />
                        <span>COMPARAR</span>
                    </label>
                </div>
            );
        }

        return null;
    }

    renderTabs() {
        const { render } = this.state;

        return (
            <div className="tab-with-options">
                <Tabs id="datamanger_tabs" activeKey={render.tab} onSelect={(a) => this.onSelectTab(a)}>
                    <Tab eventKey="active" key="active" title="Rede Ativa">
                        {this.renderLinesActive()}
                    </Tab>
                    <Tab eventKey="draft" key="draft" title="Rascunho">
                        {this.renderLinesDraft()}
                    </Tab>
                </Tabs>
                {this.renderTabOptions(render.tab)}
            </div>
        );
    }

    renderButtons(selectedTab) {
        if ("active" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("active")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        if ("draft" === selectedTab) {
            return (
                <ButtonToolbar className="pull-right title-row-col-btns">
                    <Button onClick={() => this.onCreateClick("draft")}>CRIAR</Button>
                </ButtonToolbar>
            );
        }

        return null;
    }

    renderOperationFeedback(text, isExecuting) {
        return (
            <HandleMessage
                title={text}
                message={<LoadingSpinner />}
                style={`primary`}
                icon="transfer"
                show={isExecuting}
                small
                noButtons />
        );
    }

    render() {
        const { actions, render, message, dialog } = this.state;

        return (
            <div>
                <EditionSelector />

                <TitleRow title="Linhas" showSeparator={true}>
                    <Col className="padding-0" xs={2} sm={1} md={4}>
                        {this.renderButtons(render.tab)}
                    </Col>
                    <Col className="padding-0" xs={10} sm={11} md={8}>
                        <div className="search-bar">
                            <SearchBar onSearch={(a) => this.onSearch(a)} />
                        </div>
                    </Col>
                </TitleRow>

                <div className="margin-top-15">
                    {this.renderTabs()}
                </div>

                {this.renderActiveForm()}
                {this.renderDraftForm()}

                {
                    this.renderOperationFeedback(
                        "A Executar...",
                        actions.active.isUpdating || actions.active.isDeleting || actions.draft.isUpdating || actions.draft.isDeleting
                    )
                }
                {this.renderOperationFeedback("A Carregar Edição...", actions.isLoadingEditions)}

                <HandleMessage
                    title={message.title}
                    message={message.message}
                    style={message.style}
                    icon={message.icon}
                    show={message.show}
                    onHide={() => this.onExitMessage()} />

                <HandleDialog
                    show={dialog.show}
                    title={dialog.title}
                    message={dialog.message}
                    style={dialog.style}
                    icon={dialog.icon}
                    argument={dialog.argument}
                    onExit={(a, b) => this.onExitDialog(a, b)} />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/datamanager/lines/Lines.js